var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center vh-80 vw-100"},[_c('p',{staticClass:"loading"},[_c('b',[_vm._v("redirecionando")])])])
}]

export { render, staticRenderFns }